export {
  HTTP,
  HTTPS,
  THD_SECURE_HOSTS,
  THD_NON_SECURE_HOSTS,
  SECURE,
  HOME_DEPOT_DEV,
} from "./urls";

export { getErrorMessage, MESSAGE } from "./messages";

export const REQUEST_TIMEOUT = 20000;

export const MAX_EMAIL_PASSWORD_COMMON_SUBSTRING = 5

export const COMMON_PASSWORDS = ["111111", "11111111", "112233", "121212", "123123", "123456", "1234567", "12345678", "131313", "232323", "654321", "666666", "696969",
  "777777", "7777777", "8675309", "987654", "aaaaaa", "abc123", "abcdef", "abgrtyu", "access", "access14", "action", "albert", "alexis", "amanda", "amateur", "andrea", "andrew", "angela", "angels",
  "animal", "anthony", "apollo", "apples", "arsenal", "arthur", "asdfgh", "ashley", "august", "austin", "badboy", "bailey", "banana", "barney", "baseball", "batman", "beaver", "beavis", "bigdaddy", "bigdog", "birdie",
  "bitches", "biteme", "blazer", "blonde", "blondes", "bond007", "bonnie", "booboo", "booger", "boomer", "boston", "brandon", "brandy", "braves", "brazil", "bronco", "broncos", "bulldog", "buster", "butter", "butthead",
  "calvin", "camaro", "cameron", "canada", "captain", "carlos", "carter", "casper", "charles", "charlie", "cheese", "chelsea", "chester", "chicago", "chicken", "cocacola", "coffee", "college", "compaq", "computer",
  "cookie", "cooper", "corvette", "cowboy", "cowboys", "crystal", "dakota", "dallas", "daniel", "danielle", "debbie", "dennis", "diablo", "diamond", "doctor", "doggie", "dolphin", "dolphins", "donald", "dragon", "dreams",
  "driver", "eagle1", "eagles", "edward", "einstein", "erotic", "extreme", "falcon", "fender", "ferrari", "firebird", "fishing", "florida", "flower", "flyers", "football", "forever", "freddy", "freedom", "gandalf",
  "gateway", "gators", "gemini", "george", "giants", "ginger", "golden", "golfer", "gordon", "gregory", "guitar", "gunner", "hammer", "hannah", "hardcore", "harley", "heather", "helpme", "hockey", "hooters", "horney",
  "hotdog", "hunter", "hunting", "iceman", "iloveyou", "internet", "iwantu", "jackie", "jackson", "jaguar", "jasmine", "jasper", "jennifer", "jeremy", "jessica", "johnny", "johnson", "jordan", "joseph", "joshua", "junior",
  "justin", "killer", "knight", "ladies", "lakers", "lauren", "leather", "legend", "letmein", "little", "london", "lovers", "maddog", "madison", "maggie", "magnum", "marine", "marlboro", "martin", "marvin", "master", "matrix",
  "matthew", "maverick", "maxwell", "melissa", "member", "mercedes", "merlin", "michael", "michelle", "mickey", "midnight", "miller", "mistress", "monica", "monkey", "monster", "morgan", "mother", "mountain", "muffin",
  "murphy", "mustang", "naked", "nascar", "nathan", "naughty", "ncc1701", "newyork", "nicholas", "nicole", "nipple", "nipples", "oliver", "orange", "packers", "panther", "panties", "parker", "password", "password1",
  "password12", "password123", "patrick", "peaches", "peanut", "pepper", "phantom", "phoenix", "player", "please", "pookie", "porsche", "prince", "princess", "private", "purple", "pussies", "qazwsx", "qwerty",
  "qwertyui", "rabbit", "rachel", "racing", "raiders", "rainbow", "ranger", "rangers", "rebecca", "redskins", "redsox", "redwings", "richard", "robert", "rocket", "rosebud", "runner", "rush2112", "russia", "samantha",
  "sammy", "samson", "sandra", "saturn", "scooby", "scooter", "scorpio", "scorpion", "secret", "sexsex", "shadow", "shannon", "shaved", "sierra", "silver", "skippy", "slayer", "smokey", "snoopy", "soccer", "sophie", "spanky",
  "sparky", "spider", "squirt", "srinivas", "startrek", "starwars", "steelers", "steven", "sticky", "stupid", "success", "summer", "sunshine", "superman", "surfer", "swimming", "sydney", "taylor", "tennis", "teresa",
  "tester", "testing", "theman", "thomas", "thunder", "thx1138", "tiffany", "tigers", "tigger", "tomcat", "topgun", "toyota", "travis", "trouble", "trustno1", "tucker", "turtle", "twitter", "united", "vagina", "victor",
  "victoria", "viking", "voodoo", "voyager", "walter", "warrior", "welcome", "whatever", "william", "willie", "wilson", "winner", "winston", "winter", "wizard", "xavier", "xxxxxx", "xxxxxxxx", "yamaha", "yankee", "yankees",
  "yellow", "zxcvbn", "zxcvbnm", "zzzzzz","77777777", "123123123", "123456789", "987654321", "1234567890", "1q2w3e4r", "1qaz2wsx", "aaaaaaaa", "abcd1234", "alexander", "asdfasdf", "asdfghjkl", "chocolate", "66666666", "homedepot",
  "homedepot123", "liverpool", "qwertyuiop", "testpassword", "welcome1", "abcdefghi", "abcdefgh"];

export const isoCountries = {
  "AF" : "Afghanistan",
  "AX" : "Aland Islands",
  "AL" : "Albania",
  "DZ" : "Algeria",
  "AS" : "American Samoa",
  "AD" : "Andorra",
  "AO" : "Angola",
  "AI" : "Anguilla",
  "AQ" : "Antarctica",
  "AG" : "Antigua And Barbuda",
  "AR" : "Argentina",
  "AM" : "Armenia",
  "AW" : "Aruba",
  "AU" : "Australia",
  "AT" : "Austria",
  "AZ" : "Azerbaijan",
  "BS" : "Bahamas",
  "BH" : "Bahrain",
  "BD" : "Bangladesh",
  "BB" : "Barbados",
  "BY" : "Belarus",
  "BE" : "Belgium",
  "BZ" : "Belize",
  "BJ" : "Benin",
  "BM" : "Bermuda",
  "BT" : "Bhutan",
  "BO" : "Bolivia",
  "BA" : "Bosnia And Herzegovina",
  "BW" : "Botswana",
  "BV" : "Bouvet Island",
  "BR" : "Brazil",
  "IO" : "British Indian Ocean Territory",
  "BN" : "Brunei Darussalam",
  "BG" : "Bulgaria",
  "BF" : "Burkina Faso",
  "BI" : "Burundi",
  "KH" : "Cambodia",
  "CM" : "Cameroon",
  "CA" : "Canada",
  "CV" : "Cape Verde",
  "KY" : "Cayman Islands",
  "CF" : "Central African Republic",
  "TD" : "Chad",
  "CL" : "Chile",
  "CN" : "China",
  "CX" : "Christmas Island",
  "CC" : "Cocos (Keeling) Islands",
  "CO" : "Colombia",
  "KM" : "Comoros",
  "CG" : "Congo",
  "CD" : "Congo, Democratic Republic",
  "CK" : "Cook Islands",
  "CR" : "Costa Rica",
  "CI" : "Cote D'Ivoire",
  "HR" : "Croatia",
  "CU" : "Cuba",
  "CY" : "Cyprus",
  "CZ" : "Czech Republic",
  "DK" : "Denmark",
  "DJ" : "Djibouti",
  "DM" : "Dominica",
  "DO" : "Dominican Republic",
  "EC" : "Ecuador",
  "EG" : "Egypt",
  "SV" : "El Salvador",
  "GQ" : "Equatorial Guinea",
  "ER" : "Eritrea",
  "EE" : "Estonia",
  "ET" : "Ethiopia",
  "FK" : "Falkland Islands (Malvinas)",
  "FO" : "Faroe Islands",
  "FJ" : "Fiji",
  "FI" : "Finland",
  "FR" : "France",
  "GF" : "French Guiana",
  "PF" : "French Polynesia",
  "TF" : "French Southern Territories",
  "GA" : "Gabon",
  "GM" : "Gambia",
  "GE" : "Georgia",
  "DE" : "Germany",
  "GH" : "Ghana",
  "GI" : "Gibraltar",
  "GR" : "Greece",
  "GL" : "Greenland",
  "GD" : "Grenada",
  "GP" : "Guadeloupe",
  "GU" : "Guam",
  "GT" : "Guatemala",
  "GG" : "Guernsey",
  "GN" : "Guinea",
  "GW" : "Guinea-Bissau",
  "GY" : "Guyana",
  "HT" : "Haiti",
  "HM" : "Heard Island & Mcdonald Islands",
  "VA" : "Holy See (Vatican City State)",
  "HN" : "Honduras",
  "HK" : "Hong Kong",
  "HU" : "Hungary",
  "IS" : "Iceland",
  "IN" : "India",
  "ID" : "Indonesia",
  "IR" : "Iran, Islamic Republic Of",
  "IQ" : "Iraq",
  "IE" : "Ireland",
  "IM" : "Isle Of Man",
  "IL" : "Israel",
  "IT" : "Italy",
  "JM" : "Jamaica",
  "JP" : "Japan",
  "JE" : "Jersey",
  "JO" : "Jordan",
  "KZ" : "Kazakhstan",
  "KE" : "Kenya",
  "KI" : "Kiribati",
  "KR" : "Korea",
  "KW" : "Kuwait",
  "KG" : "Kyrgyzstan",
  "LA" : "Lao People's Democratic Republic",
  "LV" : "Latvia",
  "LB" : "Lebanon",
  "LS" : "Lesotho",
  "LR" : "Liberia",
  "LY" : "Libyan Arab Jamahiriya",
  "LI" : "Liechtenstein",
  "LT" : "Lithuania",
  "LU" : "Luxembourg",
  "MO" : "Macao",
  "MK" : "Macedonia",
  "MG" : "Madagascar",
  "MW" : "Malawi",
  "MY" : "Malaysia",
  "MV" : "Maldives",
  "ML" : "Mali",
  "MT" : "Malta",
  "MH" : "Marshall Islands",
  "MQ" : "Martinique",
  "MR" : "Mauritania",
  "MU" : "Mauritius",
  "YT" : "Mayotte",
  "MX" : "Mexico",
  "FM" : "Micronesia, Federated States Of",
  "MD" : "Moldova",
  "MC" : "Monaco",
  "MN" : "Mongolia",
  "ME" : "Montenegro",
  "MS" : "Montserrat",
  "MA" : "Morocco",
  "MZ" : "Mozambique",
  "MM" : "Myanmar",
  "NA" : "Namibia",
  "NR" : "Nauru",
  "NP" : "Nepal",
  "NL" : "Netherlands",
  "AN" : "Netherlands Antilles",
  "NC" : "New Caledonia",
  "NZ" : "New Zealand",
  "NI" : "Nicaragua",
  "NE" : "Niger",
  "NG" : "Nigeria",
  "NU" : "Niue",
  "NF" : "Norfolk Island",
  "MP" : "Northern Mariana Islands",
  "NO" : "Norway",
  "OM" : "Oman",
  "PK" : "Pakistan",
  "PW" : "Palau",
  "PS" : "Palestinian Territory, Occupied",
  "PA" : "Panama",
  "PG" : "Papua New Guinea",
  "PY" : "Paraguay",
  "PE" : "Peru",
  "PH" : "Philippines",
  "PN" : "Pitcairn",
  "PL" : "Poland",
  "PT" : "Portugal",
  "PR" : "Puerto Rico",
  "QA" : "Qatar",
  "RE" : "Reunion",
  "RO" : "Romania",
  "RU" : "Russian Federation",
  "RW" : "Rwanda",
  "BL" : "Saint Barthelemy",
  "SH" : "Saint Helena",
  "KN" : "Saint Kitts And Nevis",
  "LC" : "Saint Lucia",
  "MF" : "Saint Martin",
  "PM" : "Saint Pierre And Miquelon",
  "VC" : "Saint Vincent And Grenadines",
  "WS" : "Samoa",
  "SM" : "San Marino",
  "ST" : "Sao Tome And Principe",
  "SA" : "Saudi Arabia",
  "SN" : "Senegal",
  "RS" : "Serbia",
  "SC" : "Seychelles",
  "SL" : "Sierra Leone",
  "SG" : "Singapore",
  "SK" : "Slovakia",
  "SI" : "Slovenia",
  "SB" : "Solomon Islands",
  "SO" : "Somalia",
  "ZA" : "South Africa",
  "GS" : "South Georgia And Sandwich Isl.",
  "ES" : "Spain",
  "LK" : "Sri Lanka",
  "SD" : "Sudan",
  "SR" : "Suriname",
  "SJ" : "Svalbard And Jan Mayen",
  "SZ" : "Swaziland",
  "SE" : "Sweden",
  "CH" : "Switzerland",
  "SY" : "Syrian Arab Republic",
  "TW" : "Taiwan",
  "TJ" : "Tajikistan",
  "TZ" : "Tanzania",
  "TH" : "Thailand",
  "TL" : "Timor-Leste",
  "TG" : "Togo",
  "TK" : "Tokelau",
  "TO" : "Tonga",
  "TT" : "Trinidad And Tobago",
  "TN" : "Tunisia",
  "TR" : "Turkey",
  "TM" : "Turkmenistan",
  "TC" : "Turks And Caicos Islands",
  "TV" : "Tuvalu",
  "UG" : "Uganda",
  "UA" : "Ukraine",
  "AE" : "United Arab Emirates",
  "GB" : "United Kingdom",
  "US" : "United States",
  "UM" : "United States Outlying Islands",
  "UY" : "Uruguay",
  "UZ" : "Uzbekistan",
  "VU" : "Vanuatu",
  "VE" : "Venezuela",
  "VN" : "Viet Nam",
  "VG" : "Virgin Islands, British",
  "VI" : "Virgin Islands, U.S.",
  "WF" : "Wallis And Futuna",
  "EH" : "Western Sahara",
  "YE" : "Yemen",
  "ZM" : "Zambia",
  "ZW" : "Zimbabwe"
};

export const WEBAUTHN_UPDATED_RPID_LS_KEY = "u";
export const WEBAUTHN_UPDATED_RPID_LS_VALUE = "y";
